import React, { useEffect } from 'react';
import ReactGA from 'react-ga4'
//componets
import FlNav from './landingComponents/Navbar';
import FlFooter from './landingComponents/Footer';

import { Link } from 'react-router-dom';

import fondo from '../../assets/img/landingPage/fondo.png';
import Webinar01 from '../../assets/img/landingPage/webinars/Webinar-01.png';
import Webinar02 from '../../assets/img/landingPage/webinars/Webinar-02.png';
import Webinar03 from '../../assets/img/landingPage/webinars/Webinar-03.png';
import Webinar04 from '../../assets/img/landingPage/webinars/Webinar-04.png';
import Webinar05 from '../../assets/img/landingPage/webinars/Webinar-05.png';
import Webinar06 from '../../assets/img/landingPage/webinars/Webinar-06.png';

import dashboard from '../../assets/img/landingPage/commander/Comander-home.png';
import icon_free from '../../assets/img/landingPage/freeIcon.svg'
import icon_expo from '../../assets/img/landingPage/expoIcon.svg'
import icon_dyn from '../../assets/img/landingPage/dynamicIcon.svg'

import features_1 from '../../assets/img/landingPage/commander/Commander-01.png'
import features_2 from '../../assets/img/landingPage/commander/Commander_02.png'
import features_3 from '../../assets/img/landingPage/commander/Commander_03.png'



import icn_1 from '../../assets/img/landingPage/cloud/KeyBeneffits_Cloud-01.svg'
import icn_2 from '../../assets/img/landingPage/cloud/KeyBeneffits_Cloud-02.svg'
import icn_3 from '../../assets/img/landingPage/cloud/KeyBeneffits_Cloud-03.svg'

import rocket from '../../assets/img/landingPage/rocket.png'
import tablet from '../../assets/img/landingPage/tabletApi.png'

import logo from '../../assets/img/logos/AVAP_Commander_white.svg'
import dividerbg from '../../assets/img/landingPage/hexagono-horizonte.png'


import user from '../../assets/img/ui_icons/Icon fa-regular-user.svg'
import download from '../../assets/img/ui_icons/Icon akar-download.svg'
import key from '../../assets/img/ui_icons/Icon akar-key.svg'
import doc from '../../assets/img/ui_icons/fa-doc.svg'

import gradientbottom from '../../assets/img/landingPage/gradientbottom.png'

import frameTablet from '../../assets/img/landingPage/iPad_16.9.png'

import lg_cloud from '../../assets/img/logos/AVAP_Cloud_negativo.svg'

import Favicon from '../../assets/img/Favicon_AVAP_Framework.png'

const Webinars = () => {

    useEffect(() =>{

        if (/*config.url != 'https://avs-primary-pre.101obex.mooo.com' &&*/ true){
            ReactGA.initialize('G-MQZQJN7TQL');
            ReactGA.send({ hitType: 'pageview', page: window.location.pathname, title: 'Avap Framework Commander Page' });
            }

    }, [])

    useEffect(() => {
        // favicon 
        const link = document.createElement('link');
        link.rel = 'icon';
        link.href = Favicon; // Usa la ruta importada directamente
        document.head.appendChild(link);
    
        // clean favicon 
        return () => {
          document.head.removeChild(link);
        };
      }, []);

    useEffect(() => {

        document.body.classList.add('dark-bg');
        return () => {
            document.body.classList.remove('dark-bg');
        };

    }, []);


    return (
        <>
            <FlNav></FlNav>
            <div id="pricing"
            className="fl-webinar bg-black text-white"
            style={{ backgroundImage: `url(${fondo})` }}
            >
                {/* Encabezado */}
                <section className="w-100 webinarHeader text-center noGradient ">
                   
                    <h1 className="fl-title m-0">Webinars</h1>
                    <p className="fl-txt-container-s">
                        Explore our upcoming and on-demand webinars designed to help partners, developers, and technology leaders deepen their understanding of AVAP Framework and the API-Driven ecosystem. Whether you’re just getting started or looking to scale your solutions, our sessions cover product updates, technical deep dives, partner onboarding, and real-world use cases.
                    </p>
                </section>

                <section className='container pb-3 '>
                <div className="row">
                
                {/* Tarjeta 1 */}
                <div className="col-lg-4 col-md-6 mb-2 pb-4">
                    <div className="card-webinar h-100">
                        <div className="card-webinar-header">
                            <img src={Webinar01} alt="Webinar 01" className="webinar-header-img" />
                        </div>
                    <div className="card-webinar-body">
                        <div style={{display: "flex", gap: 12, marginBottom: 8}}>
                            <span className="fl-label-2 ">Webinar</span>
                            <span className="fl-label-2">ES - EN</span>
                        </div>
                        <h1 className="fl-subtitle-xs m-0">AVAP Connect <br/> Onboarding</h1>
                        <p className='text-date'>ON DEMAND</p>
                        <p className='pb-4'>Duration: 20 Minutes</p>
                        
                        
                       {/*Boton Registro*/}  
                        <a 
                        className="glowBtn-black-2" 
                        style={{ zIndex: 2 }} 
                        href="/webinar-onboarding">
                            <span className="btnInner"> On Demand </span>
                        </a>
                    </div>
                    </div>
                
                </div>

                {/* Tarjeta 2 */}
                <div className="col-lg-4 col-md-6 mb-2 pb-4">
                    <div className="card-webinar h-100">
                        <div className="card-webinar-header">
                         <img src={Webinar02} alt="Webinar 02" className="webinar-header-img" />
                    </div>
                    <div className="card-webinar-body">
                        <div style={{display: "flex", gap: 12, marginBottom: 8}}>
                            <span className="fl-label-2">Webinar</span>
                            <span className="fl-label-2">ES</span>
                        </div>
                        
                        <h1 className="fl-subtitle-xs m-0">Introduction to Virtual API Development</h1>
                        <p className='text-date '>ON DEMAND</p> 
                        <p className='pb-4'>Duration: 45 Minutes</p>
                        
                        <a className="glowBtn-black-2" 
                        style={{zIndex: 2}} 
                        href="/webinar-virtual-api">
                            <span className="btnInner">On Demand</span>
                        </a> 
                    </div>
                    </div>
                </div>

                {/* Tarjeta 3 */}
                <div className="col-lg-4 col-md-6 mb-2 pb-4">
                    <div className="card-webinar h-100">
                        <div className="card-webinar-header">
                            <img src={Webinar03} alt="Webinar 03" className="webinar-header-img" />
                        </div>
                        <div className="card-webinar-body">
                           <div style={{display: "flex", gap: 12, marginBottom: 8}}>
                                <span className="fl-label-2">Webinar</span>
                                <span className="fl-label-2">EN</span>
                            </div>
                            <h1 className="fl-subtitle-xs m-0">AVAP Framework (Overview)</h1>
                            <p className='text-date'>ON DEMAND</p>
                            <p className='pb-0'>Duration: 45 Minutes</p>
                            
                            <a className="glowBtn-black-2" 
                            style={{zIndex: 2}} 
                            href='/webinar-framework'>
                            <span className="btnInner">On Demand </span>
                            </a> 
                        </div>
                    </div>
                </div> 
                
                 {/* Tarjeta 4 */}
                <div className="col-lg-4 col-md-6 mb-2 pb-4">
                    <div className="card-webinar h-100">
                        <div className="card-webinar-header">
                            <img src={Webinar04} alt="Webinar 04" className="webinar-header-img" />
                        </div>
                        <div className="card-webinar-body">
                           <div style={{display: "flex", gap: 12, marginBottom: 8}}>
                                <span className="fl-label-2">Webinar</span>
                                <span className="fl-label-2">ES</span>
                            </div>
                            <h1 className="fl-subtitle-xs m-0">AVAP Virtual Server – More Than an API Manager</h1>
                            <p className='text-date'>Oct 7, 2025</p>
                            <p className=''>Duration: 45 Minutes</p>
                            
                            <a className="glowBtn-black-2" 
                            style={{zIndex: 2}} 
                            href='/webinar-vs'>
                            <span className="btnInner"> More Information </span>
                            </a> 
                        </div>
                    </div>
                </div>

                {/* Tarjeta 5 */}
                <div className="col-lg-4 col-md-6 mb-2 pb-4">
                    <div className="card-webinar h-100">
                        <div className="card-webinar-header">
                            <img src={Webinar05} alt="Webinar 05" className="webinar-header-img" />
                        </div>
                        <div className="card-webinar-body">
                           <div style={{display: "flex", gap: 12, marginBottom: 8}}>
                                <span className="fl-label-2">Webinar</span>
                                <span className="fl-label-2">ES</span>
                            </div>
                            <h1 className="fl-subtitle-xs m-0">AVAP Cloud & AVAP Cloud AWS Edition</h1>
                            <p className='text-date'>Oct 29, 2025</p>
                            <p className=''>Duration: 45 Minutes</p>
                            
                            <a className="glowBtn-black-2" 
                            style={{zIndex: 2}} 
                            href="/webinar-cloud-aws">
                            <span className="btnInner"> More Information </span>
                            </a> 
                        </div>
                        </div>
                </div>
              

                {/* Tarjeta 6 */}
                <div className="col-lg-4 col-md-6 mb-2 pb-4">
                    <div className="card-webinar h-100">
                        <div className="card-webinar-header">
                            <img src={Webinar06} alt="Webinar 06" className="webinar-header-img" />
                        </div>
                        <div className="card-webinar-body">
                           <div style={{display: "flex", gap: 12, marginBottom: 8}}>
                                <span className="fl-label-2">Webinar</span>
                                <span className="fl-label-2">ES</span>
                            </div>
                            <h1 className="fl-subtitle-xs m-0">Time to Share: AVAP Solution</h1>
                            <p className='text-date'>Nov 20, 2025</p>
                            <p className='m-0'>Duration: 30 Minutes</p>
                            <br />
                            <a className="glowBtn-black-2" 
                            style={{zIndex: 2}} 
                            href="/webinar-time-to-share">
                            <span className="btnInner"> More Information </span>
                            </a> 
                        </div>
                    </div>
                </div>
                    
                </div>
                </section>
            </div>
            
            
                {/* Features */}
                {/*    <section className="container pb-5">
                    <div className="row">
                        <div className="col-md-4 text-center">
                            <div className="fl-pill">
                                <img src={icon_free} alt="" />
                                <p>On-premise Infrastructure</p>
                            </div>
                        </div>
                        <div className="col-md-4 text-center">
                            <div className="fl-pill">
                                <img src={icon_dyn} alt="" />
                                <p>Universal Platform</p>
                            </div>
                        </div>
                        <div className="col-md-4 text-center">
                            <div className="fl-pill">
                                <img src={icon_expo} alt="" />
                                <p>Database Control</p>
                            </div>
                        </div>
                    </div>
                </section> */}

            <FlFooter></FlFooter>
        </>
    );
};

export default Webinars;
